(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mamu-pdp-telas"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-mamu-tela-input]')) return;
    const nameEl = input.closest('[data-mamu-pdp-telas]')?.querySelector('[data-mamu-tela-name]');
    if (nameEl) nameEl.textContent = input.dataset.name ?? '';
  });
  } catch(e) { console.error(e); }
})();

})();
